//import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
   // baseURL: base_url,
    //Authorization: `Bearer ${sessionStorage.getItem('token')}`
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})


//Vue.prototype.$http = axiosIns

export default axiosIns
